import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './OtherModules.component.html'
})
export class OtherModules {
  
}


// WEBPACK FOOTER //
// ./src/app/OtherNodules.component.ts